module.exports = __webpack_public_path__ + "img/logo-transparent.3d364565.png";